import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { servicePages } from "../data/servicePages";

export default function ServiceBranding() {
  return <ContentPageTemplate {...servicePages.branding} />;
}
